import type { Platform, ShareContent } from '../types';
import { buildShareUrl } from '../utils/url';
import { PlatformRegistry } from './registry';

export const qzone: Platform = {
  id: 'qzone',
  name: '分享到QQ空间',
  iconIndex: PlatformRegistry.qzone.index,
  color: PlatformRegistry.qzone.color,
  buildUrl: (content: ShareContent): string => {
    return buildShareUrl('https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey', {
      url: content.url,
      title: content.title,
      desc: content.description,
      summary: content.hashtags?.join(' '),
      pics: content.image,
    });
  },
};

